import React, { useState } from "react";
import ColorPicker from "../../../componentLibrary/ColorPicker";
import Counter from "../../../componentLibrary/Counter";
import RatingScale from "../../../componentLibrary/RatingScale";

export default function InputComponents() {
  const [selectedColor, setSelectedColor] = useState("#e1395b");
  const [rating, setRating] = useState<number | null>(null);

  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSelectedColor(event.target.value);

  return (
    <>
      <h2 className="underline">Input & Controls</h2>

      <div className="space-y-6">
        {/* Color Picker */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Color Picker
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Color selection component for theme customization and content
              theming. Used for selecting colors for modules, lessons, and other
              content elements. Provides intuitive color selection with visual
              feedback.
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <ColorPicker
              selectedColor={selectedColor}
              handleColorChange={handleColorChange}
            />
            <span className="text-sm font-medium text-gray-700">
              {selectedColor}
            </span>
          </div>
        </div>

        {/* Rating Scale */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">
            Rating Scale
          </h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Numeric rating selector rendered as a row of circular buttons.
              Supports configurable scale size, an optional label, and low/high
              end descriptors. Used in check-in flows to capture subjective
              ratings.
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-3">5-point scale</p>
            <RatingScale
              value={rating}
              onChange={setRating}
              label="How are you feeling?"
            />
          </div>
        </div>

        {/* Counter */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Counter</h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Interactive counter component for numerical inputs and displays.
              Currently used primarily for demonstration purposes in the
              component library. Can be extended for various counting and
              tracking use cases.
            </p>
          </div>
          <Counter />
        </div>
      </div>
    </>
  );
}
